import React from "react";
import "../css/Window_AC_Repair.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function Window_AC_Repair() {
  return (
    <>
        <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Expert Window AC Repair and Service</p>

          <h1 className="ac-hero-title">
           Keep Your Cool This Summer!

          </h1>

          <p className="ac-hero-subtitle">
         Window AC repair and service at your doorstep in 30 minutes. Schedule your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for Window AC Repair and Service</h2>

            <p>When the summer heat becomes unbearable, a well-functioning window air conditioner is essential for your comfor At<a className="ac-link" href="#">Jay Ambe AC Service</a> we specialize in providing top-notch <strong>Window AC repair and service </strong>  to ensure you stay cool throughout the season. With years of experience in the industry, our skilled technicians are equipped with the knowledge and tools necessary to handle all types of window air conditioning units.</p>

            <p>
            Understanding that an efficient air conditioner is vital to your home or office environment, we offer comprehensive services tailored to meet your specific needs. Our repair process begins with a thorough inspection of your unit to identify any issues—be it inadequate cooling, unusual noises, or leaks. Once diagnosed, our experts will provide you with an honest assessment and discuss the best course of action.           
             </p>

         
            <p>
      At Jay Ambe AC Service, customer satisfaction is our priority. We pride ourselves on delivering prompt service without compromising quality. Whether it’s a minor fix or a major repair job, we approach every task with professionalism and attention to detail. Our team uses high-quality replacement parts and advanced techniques to restore your window AC’s efficiency quickly.
            </p>

            <p>
          In addition to repairs, we also offer routine maintenance services designed to prolong the life of your air conditioning unit. Regular servicing can prevent breakdowns and improve energy efficiency—saving you money on utility bills while ensuring optimal performance.
            </p>

          <p>Choose Jay Ambe AC Service for reliable window AC repair and service that puts your comfort first. Contact us today for a consultation or schedule an appointment! Experience hassle-free cooling solutions that keep you refreshed all summer long!</p>
          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/window-ac-service.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
   <Herolast  />
      <Footer  />
     
    </>
  );
}
